import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LuxuryLanding } from "./components/LuxuryLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LuxuryLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;